export interface LandingWorkItem {
  /** Site slug — used for hero-deck sort/dedupe when the API is down. */
  slug: string;
  name: string;
  tagline: string;
  blurb: string;
  tags: string[];
  href: string;
  /** Self-hosted capture under /marketing/ (Vite public). */
  shotSrc: string;
  shotAlt: string;
}

export const LANDING_WORK: LandingWorkItem[] = [
  {
    slug: "franks-hot-chicken",
    name: "Franks Hot Chicken",
    tagline: "Nashville-style hot chicken — Iowa City",
    blurb:
      "Full menu with photos, Stripe checkout, live map, and three switchable themes on the shared Lumora backend.",
    tags: ["Menu", "Online ordering", "Maps"],
    href: "https://frankshotchickensmashburger.com/",
    shotSrc: "/marketing/franks-hero.jpg",
    shotAlt: "Frank's Hot Chicken site — hero and menu on mobile",
  },
  {
    slug: "alamir-auto",
    name: "Alamir Auto",
    tagline: "Dealership e-commerce",
    blurb:
      "Inventory, search and filtering, and admin-managed listings with automated backups.",
    tags: ["Inventory", "Search & filter", "Admin"],
    href: "https://alamirauto.com",
    shotSrc: "/marketing/alamir-cover.jpg",
    shotAlt: "Alamir Auto storefront branding",
  },
  {
    slug: "car-doctor",
    name: "Car Doctor",
    tagline: "Auto services — Iowa City, IA",
    blurb:
      "Custom Lumora build for an Iowa City auto shop: multi-owner staff, service catalog, drop-off and pick-up booking, and Stripe deposits — live on Cloudflare Pages while the shop domain cuts over.",
    tags: ["Auto services", "Booking", "Staff"],
    href: "https://car-doctor.pages.dev/",
    shotSrc: "/marketing/car-doctor-logo.jpg",
    shotAlt: "Car Doctor logo — chrome car mark with red EKG line",
  },
  {
    slug: "bahaa",
    name: "Bahaa Mohammad",
    tagline: "Personal site — craft and storytelling",
    blurb:
      "Photo-led marketing layout, polaroid gallery, and in-place resume — proof Lumora ships more than storefronts.",
    tags: ["Personal", "Portfolio", "Example"],
    href: "https://bahaa.lumorasites.com/",
    shotSrc: "/marketing/bahaa-hero.jpg",
    shotAlt: "Bahaa Mohammad personal site hero photography",
  },
  {
    slug: "waft",
    name: "Waft",
    tagline: "Smart candle warmer — storefront and waitlist",
    blurb:
      "Product storefront and waitlist build for a smart candle warmer venture on the shared Lumora backend. Pre-launch: no purchases yet.",
    tags: ["Storefront", "Waitlist", "Product"],
    // Planned domain (issue #1135 gives none): swap for the real production domain when live.
    href: "https://waft.lumorasites.com/",
    shotSrc: "/marketing/lumora-thumb.jpg",
    shotAlt: "Waft storefront preview",
  },
  {
    slug: "turnstill",
    name: "Turnstill",
    tagline: "Render service",
    blurb:
      "Marketing and intake site for a render service, built on the same Lumora backend and shared views.",
    tags: ["Services", "Intake", "Marketing"],
    // Planned domain (issue #1135 gives none): swap for the real production domain when live.
    href: "https://turnstill.lumorasites.com/",
    shotSrc: "/marketing/lumora-thumb.jpg",
    shotAlt: "Turnstill site preview",
  },
];
